import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import React from "react";
import { Page } from "../activities/AppPage";
import { createAsyncListenerWithCleanup } from "../utils/createAsyncListenerWithCleanup";
import { parseUrl } from "../utils/parseUrl";

export default function AppUrlListener(props: { onRequestNavigate: (page: Page) => void }) {
  const navigateToPage = React.useCallback(
    (urlString: string) => {
      const { pageName, passedProps } = parseUrl(urlString);

      if (pageName === undefined) {
        return;
      }

      console.log("navigating to", pageName, passedProps);

      props.onRequestNavigate.call(null, {
        type: pageName,
        ...passedProps,
      });
    },
    [props.onRequestNavigate]
  );

  React.useEffect(() => {
    if (Capacitor.getPlatform() === "web") {
      return navigateToPage(window.location.href);
    }

    return createAsyncListenerWithCleanup(async () => {
      const listener = await App.addListener("appUrlOpen", (event) => navigateToPage(event.url));
      return () => listener.remove();
    });
  }, [navigateToPage]);

  return null;
}
